module.exports = __webpack_public_path__ + "static/media/SCTR.be7e428a.jpg";